export default "__VITE_ASSET__CudyFC4y__"